(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-journal-article"]) return;
  try {
    
  if (!customElements.get('booth-journal-video')) {
    customElements.define('booth-journal-video', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const video = this.querySelector('video');
        const button = this.querySelector('[data-pj-video-play]');
        const label = this.querySelector('[data-pj-video-label]');
        const duration = this.querySelector('[data-pj-video-duration]');
        if (!video || !button || !label) return;
        this.dataset.ready = 'true';
        const restore = () => {
          if (video.error) { button.hidden = true; if (duration) duration.hidden = true; return; }
          const message = video.ended ? this.dataset.replayLabel : this.dataset.playLabel;
          label.textContent = message;
          button.setAttribute('aria-label', message);
          button.hidden = false;
          if (duration) duration.hidden = false;
        };
        video.addEventListener('play', () => { button.hidden = true; if (duration) duration.hidden = true; });
        video.addEventListener('pause', restore);
        video.addEventListener('ended', restore);
        video.addEventListener('error', () => { button.hidden = true; if (duration) duration.hidden = true; });
        button.addEventListener('click', () => {
          if (video.ended) video.currentTime = 0;
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(restore);
        });
        if (video.paused) restore();
      }
    });
  }
  if (!customElements.get('booth-journal-share')) {
    customElements.define('booth-journal-share', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const share = this.querySelector('[data-pj-share]');
        const copy = this.querySelector('[data-pj-copy]');
        const status = this.querySelector('[role="status"]');
        const input = this.querySelector('input');
        const manual = this.querySelector('[data-pj-manual-link]');
        if (!share || !copy || !status || !input || !manual) return;
        this.dataset.ready = 'true';
        const url = this.dataset.url;
        const shareData = {title: this.dataset.title, url};
        let sharePending = false;
        let copyPending = false;
        const manualFallback = () => {
          manual.open = true;
          input.focus();
          input.select();
          if (typeof input.setSelectionRange === 'function') input.setSelectionRange(0, input.value.length);
          status.textContent = this.dataset.failed;
        };
        const canShare = () => {
          if (!window.isSecureContext || typeof navigator.share !== 'function') return false;
          try { return typeof navigator.canShare !== 'function' || navigator.canShare(shareData); }
          catch { return false; }
        };
        if (canShare()) {
          share.hidden = false;
          share.addEventListener('click', async () => {
            if (sharePending) return;
            status.textContent = '';
            if (!canShare()) { manualFallback(); return; }
            sharePending = true;
            share.disabled = true;
            try { await navigator.share(shareData); }
            catch (error) { if (!error || error.name !== 'AbortError') manualFallback(); }
            finally { sharePending = false; share.disabled = false; }
          });
        }
        // The copy action remains useful when clipboard access is unavailable: manual fallback.
        copy.hidden = false;
        copy.addEventListener('click', async () => {
          if (copyPending) return;
          status.textContent = '';
          if (!window.isSecureContext || !navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') { manualFallback(); return; }
          copyPending = true;
          copy.disabled = true;
          try { await navigator.clipboard.writeText(url); status.textContent = this.dataset.copied; }
          catch { manualFallback(); }
          finally { copyPending = false; copy.disabled = false; }
        });
        input.addEventListener('click', () => input.select());
      }
    });
  }
  if (!customElements.get('booth-journal-comment-form')) {
    customElements.define('booth-journal-comment-form', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const form = this.closest('form');
        const body = this.querySelector('[name="comment[body]"]');
        const author = this.querySelector('[name="comment[author]"]');
        const email = this.querySelector('[name="comment[email]"]');
        const fields = this.querySelector('[data-pj-comment-fields]');
        const cancel = this.querySelector('[data-pj-comment-cancel]');
        if (!form || !body || !author || !email || !fields || !cancel) return;
        this.dataset.ready = 'true';
        const lockedOpen = this.dataset.serverState === 'errors' || this.dataset.serverState === 'posted';
        let suppressFocus = false;
        let invalidFocusPending = false;
        const resize = () => {
          body.style.height = 'auto';
          body.style.height = Math.min(Math.max(body.scrollHeight, 56), 200) + 'px';
          body.style.overflowY = body.scrollHeight > 200 ? 'auto' : 'hidden';
        };
        const expand = () => { fields.open = true; resize(); };
        fields.open = lockedOpen || [body, author, email].some(field => field.value.trim() !== '');
        cancel.hidden = false;
        body.addEventListener('focus', () => { if (!suppressFocus) expand(); });
        body.addEventListener('input', expand);
        fields.addEventListener('toggle', () => { if (lockedOpen && !fields.open) fields.open = true; });
        form.addEventListener('invalid', () => {
          expand();
          if (!invalidFocusPending) {
            invalidFocusPending = true;
            queueMicrotask(() => {
              const first = form.querySelector(':invalid');
              if (first) first.focus();
              invalidFocusPending = false;
            });
          }
        }, true);
        cancel.addEventListener('click', () => {
          body.value = '';
          resize();
          fields.open = lockedOpen;
          suppressFocus = true;
          body.focus();
          suppressFocus = false;
        });
        resize();
        if (lockedOpen) {
          const feedback = this.dataset.serverState === 'errors' ? this.querySelector('[aria-invalid="true"]') || this.querySelector('[data-pj-comment-feedback]') : this.querySelector('[data-pj-comment-feedback]');
          if (feedback) feedback.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
